import { useMemo } from 'react';
import { Brand, Themes, useTheme, useBrand } from '@sbercloud/uikit-product-utils';
export function useThemeModification() {
  var _useTheme = useTheme(),
    theme = _useTheme.theme;
  var isDarkTheme = useMemo(function () {
    return [Themes.GreenDark, Themes.PurpleDark].includes(theme);
  }, [theme]);
  return {
    isDarkTheme: isDarkTheme
  };
}
export function useBrandModification() {
  var _useBrand = useBrand(),
    brand = _useBrand.brand;
  var isDarkBrand = useMemo(function () {
    return [Brand.CloudDark, Brand.MLSpaceDark, Brand.AdminDark, Brand.SiteDark].includes(brand);
  }, [brand]);
  return {
    isDarkBrand: isDarkBrand
  };
}